import styled from 'styled-components'

import { ReactComponent as ImagePlaceholder } from '@sketch/icons/image-64'

import { Text, ButtonUnstyled, TimeAgo } from '@sketch/components'
import MarkdownDocumentDescription from '../../../shares/components/EditableDocumentDescription/MarkdownDocumentDescription'

import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.div`
  margin: 24px 80px 140px 80px; /* stylelint-disable-line scales/space */

  ${breakpoint('base', 'sm')`
    margin: 0 24px 140px 24px;  /* stylelint-disable-line scales/space */
  `}
`

export const MaxWidth = styled.div<{ $width: number }>`
  display: flex;
  flex-direction: column;
  max-width: ${({ $width }) => `${$width}`}px;
  margin: 0 auto;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0 32px 0;

  ${breakpoint('base', 'sm')`
    flex-direction: column;
  `}
`

export const Title = styled(Text.H1).attrs({
  textStyle: 'header.primary.I',
})`
  margin: 0;

  ${breakpoint('base', 'sm')`
    text-align: center;
  `}
`

export const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-left: 16px;

  ${breakpoint('base', 'sm')`
    margin-top: 16px;
    margin-left: 0px;
  `}
`

export const DocumentTypes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const VersionDescription = styled(MarkdownDocumentDescription)`
  font-size: ${({ theme }) => theme.fontSizes.C};
  line-height: ${({ theme }) => theme.lineHeights.F};

  /* We need to override <Markedown /> pre color */
  &&& {
    pre {
      color: ${({ theme }) => theme.colors.foreground.secondary.D};
    }
  }

  flex: 0 1 252px;
  margin-left: 26px; /* stylelint-disable-line scales/space */
  margin-top: 8px;

  ${breakpoint('base', 'sm')`
    flex: 1 1 100%;
    margin-top: 8px;
  `}
`

export const Description = styled(MarkdownDocumentDescription)`
  max-width: 540px;
  margin-top: 56px;
  margin-right: 44px;
  margin-bottom: 24px;
  flex: 1 1 100%;

  font-size: ${({ theme }) => theme.fontSizes.F};
  line-height: ${({ theme }) => theme.lineHeights.F};

  /* We need to override <Markedown /> pre color */
  &&& {
    pre {
      color: ${({ theme }) => theme.colors.foreground.secondary.C};
    }
  }

  ${breakpoint('base', 'sm')`
    max-width: 100%;
    margin-top: 28px;
    margin-right: 0;
    margin-bottom: 0;
  `}
`

export const Content = styled.div`
  display: flex;
  width: 100%;

  ${breakpoint('base', 'sm')`
    flex-direction: column-reverse;
  `}
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 56px;

  ${breakpoint('base', 'sm')`
    margin-top: 28px;
  `}
`

export const Detail = styled(Text.P).attrs({
  as: 'div',
  textStyle: 'copy.quaternary.standard.C',
})`
  display: inline-flex;
  align-items: center;
  margin: 0;
  white-space: nowrap;
  line-height: 1;

  :not(:last-child) {
    margin-right: 24px;
  }
`

export const MacApp = styled.svg`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`

export const Icon = styled.svg`
  width: 17px;
  height: 17px;
  margin-right: 8px;
`

export const StyledButton = styled(ButtonUnstyled)`
  margin-top: 28px;
  font-size: ${({ theme }) => theme.fontSizes.B};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  transition: color ${({ theme }) => theme.transitions.duration[1]};

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.C};
  }
`

export const NoImageThumbnail = styled.div`
  position: relative;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border-radius: ${({ theme }) => theme.radii.xxlarge};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border.B};

  ${breakpoint('base', 'sm')`
    margin: 0 -24px;
    border-radius: 0;
  `}
`

export const NoImageIcon = styled(ImagePlaceholder).attrs({ role: 'img' })`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.55;
  width: 64px;
  height: 64px;
`

export const StyledTimeAgo = styled(TimeAgo)`
  margin-left: 4px;
`

export const DropdownButton = styled(ButtonUnstyled)`
  display: flex;
  align-items: center;
  height: 40px;
  margin-right: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border: 1px solid ${({ theme }) => theme.colors.border.B};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.secondary.B};
  }
`
